import React from 'react';
import swal from 'sweetalert';
import { GridCell } from '@progress/kendo-react-grid';

export default function CellWithReaading(read, toggleActive) {
	return class extends GridCell {
		render() {
			return (
				<td>
					<button
						className="admin-k-button "
						onClick={() => {
							read(this.props.dataItem);
						}}
					>
						<i className="fas fa-pen"></i>
					</button>
					&nbsp;
					{this.props.dataItem.IsActive ? (
						<button							
							className="admin-k-button "
							onClick={() => {
								swal({
									title: 'Are you sure?',
									text: `Account for membership user, ${this.props.dataItem.FirstName} ${this.props.dataItem.LastName}, will be de-activated.`,
										
									icon: 'warning',
									buttons: {
										cancel: 'CANCEL',
										confirm: 'OK'
									},
									dangerMode: true
								}).then((value) => (value ? toggleActive(this.props.dataItem) : null));
							}}
						>
							<i className="fas fa-times-circle"></i>
						</button>
					) : (
						<button
							className="admin-k-button activate-btn"
							onClick={() => {
								swal({
									text: `Are you sure you want to re-activate ${this.props.dataItem.FirstName} ${this.props.dataItem.LastName} ?`,										
									buttons: {
										cancel: 'CANCEL',
										confirm: 'OK'
									}
								}).then((value) => (value ? toggleActive(this.props.dataItem) : null));							
							}}
						>
							<i className="fas fa-check-circle"></i>
						</button>
					)}
				</td>
			);
		}
	};
}
